// Production split: effyventure.com (+ www) serves the marketing site,
// order.effyventure.com serves the app. Any other host (localhost, Vercel
// preview URLs) keeps serving everything from one place, unchanged, so local
// dev and preview deploys aren't affected by this split.
const ORDER_HOST_PREFIX = 'order.';
const MARKETING_HOST_REGEX = /(^|\.)effyventure\.com$/;

function getHostname() {
  return typeof window !== 'undefined' ? window.location.hostname : '';
}

export function isOrderHost() {
  return getHostname().startsWith(ORDER_HOST_PREFIX);
}

export function isMarketingHost() {
  const host = getHostname();
  return MARKETING_HOST_REGEX.test(host) && !host.startsWith(ORDER_HOST_PREFIX);
}

// Where a "back to marketing site" link should point. On the real
// order.effyventure.com subdomain that's a different host, so it has to be
// a hard link rather than an in-app route ("/" there is the login page).
export function marketingHomeUrl() {
  return isOrderHost() ? 'https://effyventure.com' : '/';
}
